import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import api from "../lib/api";
import { AddToMealLogButton } from "../components/AddToMealLogButton";

export default function Snacks() {
  const [snacks, setSnacks] = useState([]);
  useEffect(() => { api.get("/content/snacks").then((r) => setSnacks(r.data)); }, []);

  return (
    <AppShell title="15 snacks saludables" subtitle="Opciones rápidas, ricas en proteína y fáciles de llevar.">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {snacks.map((s) => (
          <article key={s.id} className="mep-card overflow-hidden">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={s.image} alt={s.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-5">
              <h3 className="font-display text-lg font-medium tracking-tight">{s.name}</h3>
              <p className="text-sm text-[var(--mep-text-muted)] mt-2">{s.description}</p>
              <div className="flex gap-2 mt-4 text-xs">
                <span className="mep-pill-pink !text-[10px] !py-1 !px-2">{s.protein_g} g proteína</span>
                <span className="mep-pill-gold !text-[10px] !py-1 !px-2">{s.calories} kcal</span>
              </div>
              <AddToMealLogButton item={{ ...s, kcal: s.calories }} defaultMealType="snacks" />
            </div>
          </article>
        ))}
      </div>
    </AppShell>
  );
}
